import dayjs from 'dayjs';
import { useParams } from 'react-router';
import useScheduleCoachDetailForAdminQuery from '#hooks/queries/schedules/useScheduleCoachDetailForAdminQuery';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { dateDayKoFormatter } from '#utils/dateFormatter';
import Loading from 'src/components/molecules/Loading';
import useSetCoachIdByPathState from 'src/features/Calendar/hooks/useSetCoachIdByPathState';
import * as S from './styles';

export function WeeklyCalenderDetailForAdmin() {
  const { lectureId: registeredLectureId } = useParams();
  useSetCoachIdByPathState();

  const { data, isLoading } = useScheduleCoachDetailForAdminQuery({
    scheduleId: registeredLectureId
  });

  const todayDate = data && dateDayKoFormatter(data.taughtAt);
  const startTime = dayjs(data?.taughtAt).format('HH:mm');
  const endTime = dayjs(data?.endedAt).format('HH:mm');

  if (isLoading) {
    return <Loading />;
  }

  if (!registeredLectureId || !data) {
    return <div style={{ color: '#fff' }}>데이터가 없습니다</div>;
  }
  return (
    <PrevHeaderBarWithTitleTemplate title="" defaultBackground>
      <S.Container>
        <S.TimeHeader>
          <S.DateBox>{todayDate}</S.DateBox>
          <S.TimeBox>
            {startTime}
            <S.TimeDivider>-</S.TimeDivider>
            {endTime}
          </S.TimeBox>
        </S.TimeHeader>

        <S.CoachNameWrapper>
          <S.CoachName>{data.coachName}</S.CoachName> 트레이너
        </S.CoachNameWrapper>

        <div>
          <S.LabeledInfo>
            <S.LabeledInfoTitle>회원</S.LabeledInfoTitle>
            <S.LabeledInfoDescription>
              {data?.personName}
            </S.LabeledInfoDescription>
          </S.LabeledInfo>

          <S.LabeledInfo>
            <S.LabeledInfoTitle>수업</S.LabeledInfoTitle>
            <S.LabeledInfoDescription>{data?.title}</S.LabeledInfoDescription>
          </S.LabeledInfo>

          <S.LabeledInfo>
            <S.LabeledInfoTitle>회차</S.LabeledInfoTitle>
            <S.LabeledInfoDescription>
              {data?.round}/{data?.totalRound}회차
            </S.LabeledInfoDescription>
          </S.LabeledInfo>
        </div>
      </S.Container>
    </PrevHeaderBarWithTitleTemplate>
  );
}
